import { useMemo } from 'react';

import { isQuillContentEmpty } from '@gearbelt/global';
import DOMPurify from 'dompurify';

import { cn } from '@/lib/utils';

export default function Description({ content, className }: { content: string; className?: string }) {
  const sanitizedContent = useMemo(() => DOMPurify.sanitize(content), [content]);

  if (isQuillContentEmpty(sanitizedContent)) {
    return null;
  }

  return <div className={cn('awa-headings text-sm', className)} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
}
